import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Body from "./components/body";
import Home from "./components/RoutePages/home";
import ScrollToTop from "./components/ScrollToTop";
import ChatSection from "./components/ChatSection/ChatSection";

// Home ships in the main bundle — it is the landing page for most visits, so
// splitting it would only add a round trip. Everything else loads on demand.
const TermsOfUse = lazy(() => import("./components/LegalSection/TermsOfUse"));
const PrivacyPolicy = lazy(() =>
  import("./components/LegalSection/PrivacyPolicy")
);
const CookiePolicy = lazy(() =>
  import("./components/LegalSection/CookiePolicy")
);
const PolicyPage = lazy(() => import("./components/LegalSection/PolicyPage"));
const Category = lazy(() => import("./components/CategoryPage/category"));
const SingleProduct = lazy(() =>
  import("./components/SingleProduct/SingleProduct")
);
const SearchResults = lazy(() =>
  import("./components/SearchResults/SearchResults")
);
const AllProducts = lazy(() => import("./components/Products/AllProducts"));
const Certifications = lazy(() =>
  import("./components/RoutePages/Certifications")
);
const NotFound = lazy(() => import("./components/NotFound/NotFound"));

// Chunks load in milliseconds on a warm connection, so this only ever flashes
// on a cold one. Sized to hold the viewport and avoid a layout jump.
const RouteFallback = () => (
  <div className="min-h-[60vh]" aria-busy="true" aria-live="polite" />
);

// Interseller is the shop. Company, services, careers, blog and press live on
// quantarock.in — those paths are 301'd across in firebase.json rather than
// duplicated here.
const AppRoutes = () => {
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <ChatSection />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Body />}>
            <Route path="/" element={<Home />} />
            <Route path="/all-products" element={<AllProducts />} />
            <Route path="/category/:slug" element={<Category />} />
            <Route
              path="/category/:categorySlug/:productSlug"
              element={<SingleProduct />}
            />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/legal/terms" element={<TermsOfUse />} />
            <Route path="/legal/privacy" element={<PrivacyPolicy />} />
            <Route path="/legal/cookies" element={<CookiePolicy />} />
            <Route
              path="/policies/delivery"
              element={<PolicyPage policy="delivery" />}
            />
            <Route
              path="/policies/returns"
              element={<PolicyPage policy="returns" />}
            />
            <Route
              path="/policies/warranty"
              element={<PolicyPage policy="warranty" />}
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
